import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const CardBody = ({ children }: Props) => {
  return <div className='px-4 py-5 sm:px-3 sm:pb-3 sm:pt-0'>{children}</div>;
};
export default CardBody;
